



























































import { Component, Prop, Vue } from 'vue-property-decorator';
import PhoneCountryCodeInput from '@/components/PhoneCountryCodeInput.vue';
import { Meeting } from '@/models/CalendarEntries';
import { PhoneCountryCode } from '@/models/PhoneCountryCode';

@Component({
    components: {
        PhoneCountryCodeInput
    }
})
export default class BookingForm extends Vue {
    [x: string]: any;
    @Prop() timeSlotValid!: boolean;
    @Prop() countryCodes!: PhoneCountryCode[];
    acceptChecked: boolean = false;
    formSubmitClicked: boolean = false;
    tmpAddress: string = '';
    tmpPostalCode: string = '';
    tmpCity: string = '';
    formData: Meeting = {
        id: '',
        person: '',
        startDate: '',
        endDate: '',
        meetingType: '',
        bookedManually: false,
        customerName: '',
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        customerMessage: '',
        zoomMeetingInfo: '',
        token: ''
    };
    get formValid(): boolean {
        if (this.formData.customerName === '') {
            return false;
        }
        if (!this.mailValid) {
            return false;
        }
        if (this.formData.customerPhone === '') {
            return false;
        }
        if (this.tmpPostalCode === '') {
            return false;
        }
        if (this.tmpCity === '') {
            return false;
        }
        if (this.formData.customerMessage === '') {
            return false;
        }
        return true;
    }
    get mailValid(): boolean {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/i.test(this.formData.customerEmail);
    }
    get formComplete(): boolean {
        return this.acceptChecked && this.timeSlotValid && this.formValid;
    }
    submitBooking() {
        this.formSubmitClicked = true;
        if (this.formComplete) {
            this.formData.customerAddress = `${this.tmpAddress}, ${this.tmpPostalCode} ${this.tmpCity}`;
            this.$emit('submitBooking', this.formData);
        }
    }
}
